import React, {Component} from 'react';
import PropTypes from 'prop-types';

class ProcessButton extends Component {
    static propTypes = {
        isLoading: PropTypes.bool.isRequired,
        children: PropTypes.node.isRequired
    };
    static defaultProps = {};
    state = {};

    render() {
        const {isLoading, children, disabled, ...props} = this.props;
        return (
            <button disabled={disabled || isLoading} {...props}>
                {
                    isLoading
                        ? <i className="fa fa-circle-o-notch fa-spin"/>
                        : children
                }
            </button>
        );
    }
}

export default ProcessButton;


// WEBPACK FOOTER //
// ./src/controls/ProcessButton.js